import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import partnersBanner from "../../Images/academic/academic-partner-banner.webp";

// PDF imports
import academic1 from "../../Images/academic/Academic Calendar 2024- 25.pdf";
import academic2 from "../../Images/academic/Academic Calendar 2025- 26.pdf";

const AcademicCalander = () => {
    // 📘 Dynamic academic calendar data
    const academicCalendars = [
        {
            name: "Academic Calendar 2024–25",
            file: academic1,
        },
        {
            name: "Academic Calendar 2025–26",
            file: academic2,
        },
    ];

    return (
        <>
            <Topnav />

            {/* Hero Banner Section */}
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${partnersBanner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content text-center text-white">
                            <h1>Academic Calendar</h1>
                            <ol className="breadcrumb mt-3 mb-0 justify-content-center">
                                <li className="breadcrumb-item">
                                    <a
                                        href="/"
                                        style={{ color: "#fff", textDecoration: "none" }}
                                    >
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Academic Calendar
                                </li>
                            </ol>
                            <hr className="section-divider mx-auto" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Academic Calendar Section */}
            <section className="container ptb-50">
                <div className="row justify-content-around" id="academic-calendar">
                    <div className="col-lg-12" style={{ padding: 0 }}>
                        <h2 className="text-blue section-title-start modern-title">Academic Calendar</h2>
                        <hr className="divider" style={{ marginTop: "auto" }} />

                        <table className="table table-bordered" style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "70%" }}>Academic Year</th>
                                    <th style={{ width: "30%" }}>Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                {academicCalendars.map((calendar, index) => (
                                    <tr key={index}>
                                        <td>{calendar.name}</td>
                                        <td>
                                            <a
                                                href={calendar.file}
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{ color: "#9d2b75" }}
                                            >
                                                Click here
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <hr />
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default AcademicCalander;
